import { call, takeLatest, put } from 'redux-saga/effects';

import * as api from '../../api';

import {
  FETCH_REGION_REQUEST,
  fetchRegionSuccess,
  fetchRegionFailure
} from 'store/region/actions';

function* handleFetchRegionRequest(action) {
  try {
    const response = yield call(api.fetchRegion, action.payload.id);

    yield put(fetchRegionSuccess(response));
  } catch (err) {
    yield put(fetchRegionFailure(err));
  }
}

export default function* regionsSaga() {
  return yield takeLatest(FETCH_REGION_REQUEST, handleFetchRegionRequest);
}



// WEBPACK FOOTER //
// ./src/store/region/sagas.js